import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-address-link',
    templateUrl: './address-link.template.html',
})
export class AddressLinkComponent implements OnChanges {
    @Input() fullLocation?: string;
    url: string;

    ngOnChanges(): void {
        if (this.fullLocation) {
            this.url = this.getMapsLink(this.fullLocation);
        }
    }

    private getMapsLink(fullLocation: string): string {
        return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullLocation);
    }
}
